export const NavDataConfig = [
    {
        to: 'home',
        label: 'Home',
    },
    {
        to: 'about',
        label: 'About',
    },
    {
        to: 'ourExpertise',
        label: 'OurExpertise',
    },
    {
        to: 'prjects',
        label: 'Projects',
    },
    {
        to: 'services',
        label: 'Services',
    },
    {
        to: 'certificates',
        label: 'Certificates',
    },
    {
        to: 'ourTeam',
        label: 'OurTeam',
    },
    
    
    
    
    /* {
        to: 'contact',
        label: 'Contact',
    }, */
]